import React from "react";
import { motion } from "framer-motion";
import { LayoutDashboard, Briefcase, History as HistoryIcon, Settings } from "lucide-react";
import type { View } from "../../types";

interface BottomNavProps {
    view: View;
    setView: (view: View) => void;
    setIsSettingsOpen: (isOpen: boolean) => void;
}

const BottomNav: React.FC<BottomNavProps> = ({ view, setView, setIsSettingsOpen }) => {
    const navItems = [
        { id: "dashboard", icon: LayoutDashboard, label: "Feed" },
        { id: "brand", icon: Briefcase, label: "Brand" },
        { id: "history", icon: HistoryIcon, label: "History" },
    ];

    return (
        <nav className="md:hidden fixed bottom-0 left-0 right-0 h-20 bg-black/80 backdrop-blur-2xl border-t border-white/5 z-50 flex items-center justify-around px-6 pb-safe">
            {navItems.map((item) => (
                <button
                    key={item.id}
                    onClick={() => setView(item.id as View)}
                    className={`flex flex-col items-center gap-1.5 transition-all ${view === item.id ? "text-primary" : "text-white/40"
                        }`}
                >
                    <item.icon size={20} />
                    <span className="text-[10px] font-bold uppercase tracking-widest">{item.label}</span>
                    {view === item.id && (
                        <motion.div
                            layoutId="activeTabMobile"
                            className="w-1 h-1 rounded-full bg-primary"
                        />
                    )}
                </button>
            ))}
            <button
                onClick={() => setIsSettingsOpen(true)}
                className="flex flex-col items-center gap-1.5 text-white/40"
            >
                <Settings size={20} />
                <span className="text-[10px] font-bold uppercase tracking-widest">Settings</span>
            </button>
        </nav>
    );
};

export default BottomNav;
